export default function CavernicolAppLogo({ inverse = false, compact = false, className = '' }) {
  const ink = inverse ? '#FFFFFF' : '#10131A';

  return (
    <span className={`cav-logo ${compact ? 'cav-logo--compact' : ''} ${className}`.trim()}>
      <svg
        className="cav-logo__mark"
        viewBox="0 0 64 64"
        role="img"
        aria-label="CavernicolApp"
      >
        <defs>
          <linearGradient id="cavernicolapp-mark" x1="8" y1="56" x2="56" y2="6" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F72585" />
            <stop offset="0.56" stopColor="#F05A35" />
            <stop offset="1" stopColor="#FFB02E" />
          </linearGradient>
        </defs>
        <path
          d="M51.5 42.7C47.4 51.1 39.9 56 30.3 56 16.9 56 7 45.7 7 32S16.9 8 30.3 8c8.6 0 15.7 3.7 20 10.2l-10 7.2c-2.2-3.2-5.3-5-9.6-5-6.8 0-11.5 4.8-11.5 11.6 0 6.9 4.7 11.7 11.5 11.7 4.8 0 8.2-2.2 10.3-6l10.5 5Z"
          fill="url(#cavernicolapp-mark)"
        />
        <path d="M31.5 27.2 43 32l-11.5 4.8V27.2Z" fill={inverse ? '#10131A' : '#FFFFFF'} />
        <circle cx="49.5" cy="13" r="3" fill="#F72585" />
        <circle cx="55.5" cy="7.5" r="2" fill="#FFB02E" />
        <path d="M48.8 18.2 54 12.7" stroke="#F05A35" strokeWidth="2.4" strokeLinecap="round" />
      </svg>
      {!compact && (
        <span className="cav-logo__wordmark" style={{ color: ink }}>
          <span>Cavernicol</span><strong>App</strong>
          <small>IA que mueve tu negocio</small>
        </span>
      )}
    </span>
  );
}
